module.exports = __webpack_public_path__ + "subscription-CTA-ba3d720fd05f9717b481.png";